<template>
	<div>
		<div class="owl-carousel owl-loaded owl-nav-dots-inner" data-options='{"items":1,"loop":true,"autoplay":true}'>
			<div class="owl-item">
				<div class="slider-item" style="background-color:#196564bf;">
					<div class="container">
						<div class="slider-item-inner">
							<div class="slider-item-caption-left slider-item-caption-white">
								<h4 class="slider-item-caption-title">The Ultimate Trade Enabler</h4>
								<p class="slider-item-caption-desc">Boost your business with Us</p>
							</div>
							<img class="slider-item-img-right" src="@/assets/img/test_slider/1-i.png" alt="Image Alternative text" title="Image Title" style="top: 60%; width: 56%;" />
						</div>
					</div>
				</div>
			</div>
			<div class="owl-item">
				<div class="slider-item" style="background-color:#196564bf;">
					<div class="container">
						<div class="slider-item-inner">
							<div class="slider-item-caption-right slider-item-caption-white">
								<h4 class="slider-item-caption-title">Products and Services</h4>
								<p class="slider-item-caption-desc">All in one platform.</p>
							</div>
							<img class="slider-item-img-left" src="@/assets/img/test_slider/2-i.png" alt="Image Alternative text" title="Image Title" style="transform:translateY(-50%) rotate(14deg); width: 55%;" />
						</div>
					</div>
				</div>
			</div>
			<div class="owl-item">
				<div class="slider-item" style="background-color:#196564bf;">
					<div class="container">
						<div class="slider-item-inner">
							<div class="slider-item-caption-left slider-item-caption-white">
								<h4 class="slider-item-caption-title">Talent for your company</h4>
								<p class="slider-item-caption-desc">Find, Recruit and Train your future employee here</p>
							</div>
							<img class="slider-item-img-right" src="@/assets/img/test_slider/3-i.png" alt="Image Alternative text" title="Image Title" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="gap"></div>
		<ShopByProducts />
		<div class="gap"></div>
		<ShopByServices />
		<div class="gap"></div>
		<RecommendedProducts />
		<div class="gap"></div>
		<div class="slider-item-sm" style="background-color:#cc0d009c;">
			<div class="container">
				<div class="slider-item-inner">
					<div class="slider-item-caption-left slider-item-caption-white">
						<h4 class="slider-item-caption-title">Time to Upgrade Your Business</h4>
						<p class="slider-item-caption-desc">Take action now!</p><a data-effect="mfp-move-from-top" class="popup-text" href="#nav-account-dialog">Register Now</a>
					</div>
					<img class="slider-item-img" src="@/assets/img/test_slider/7-i.png" alt="Image Alternative text" title="Image Title" style="right: 0; bottom: 0; width: 42%;" />
				</div>
			</div>
		</div>
		<div class="gap"></div>
		<RecommendedServices />
		<div class="gap"></div>
		<div class="slider-item-sm" style="background-image:url(/img/partoftoolaku.png);">
			<div class="slider-item-mask"></div>
			<div class="container">
				<div class="slider-item-inner">
					<div class="slider-item-caption-right slider-item-caption-white">
						<h4 class="slider-item-caption-title">Become part of Toolaku Community</h4>
						<p class="slider-item-caption-desc">And connect to thousands of potential clients</p>
					</div>
				</div>
			</div>
		</div>
		<div class="gap"></div>
	</div>
</template>

<script>

	import RecommendedProducts from '@/components/RecommendedProducts'
	import RecommendedServices from '@/components/RecommendedServices'
	import ShopByProducts from '@/components/ShopByProducts'
	import ShopByServices from '@/components/ShopByServices'

	export default {
		components: {
			RecommendedProducts,
			RecommendedServices,
			ShopByProducts,
			ShopByServices
		},
		data() {
			return {
				authKey: null
			}
		},
		created() {
			  var evt = new CustomEvent('home-owl-initialize', {  });
  			  window.dispatchEvent(evt);
		}
	}
</script>
